import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AttractorTimeout from '../warning/attractorTimeout';

const IntroductionScreen = ({ config, gameData, passRefUpward}) => {
    AttractorTimeout(config, passRefUpward);

    useEffect(() => {
        const playData = [];
        window.sessionStorage.setItem('playData', JSON.stringify(playData));
    }, []);

    const {
        image_blocks,
        text,
        start_link_text,
    } = config.screens.introductionScreen;

    return (
        <div className='introductionScreen'>
            <p className="intro-text">{ text }</p>

            {image_blocks && (
                <div className="introductionScreen__blocks">
                    {image_blocks.map((imageBlock, idx) => (
                        <div className="introductionScreen__blocks-block" key={idx}>
                            <span className="introductionScreen__blocks-block-image">
                                <img alt="" src={`img/${imageBlock.image}`} />
                            </span>
                            <p>{imageBlock.text}</p>
                        </div>
                    ))}
                </div>
            )}

            <div className='App__button'>
                <div className='App__button-large-container'>
                    <button>
                        <Link to={`/executables/${gameData.gameClass}/attractor`}>{start_link_text}</Link>
                    </button>
                    <span> </span> {/* Decorative span */}
                    <span> </span> {/* Decorative span */}
                </div>
            </div>
        </div>
    );
};

export default IntroductionScreen;
